import {
  customSemantics,
  shape,
  DENSITY,
  MODE
} from '../../flows/shared/LayoutTheme/layoutTheme'

export const buildThemeSettings = (
  isHpx: boolean,
  overrides?: Record<string, unknown>
) => ({
  customSemantics: customSemantics(isHpx),
  mode: MODE,
  shape: shape(isHpx),
  density: DENSITY,
  ...overrides
})
